import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import brandingService from "../../services/brandingService";

const useBranding = ({ accountExternalId }: { accountExternalId: string }) =>
    useQuery([queryKeys.branding, accountExternalId], () => brandingService.fetchBranding(), {
        enabled: !!accountExternalId,
    });

export default useBranding;
